export class AppConstants {
  public static OauthCallBack = 'oauth_callback';
  public static ReturnUrl = 'return_url';
  public static authenticationStorageKey = 'authentication';
  public static optionListStorageKey = 'options';
  public static LOCALE = 'locale';
  public static ISB_EULA = 'isb_eula';
  public static ShowStats = "show_stats";
}
